import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-slate-900 mb-4">404</h1>
        <p className="text-xl text-slate-600 mb-8">找不到頁面</p>
        <Link to="/" className="bg-gold-600 text-white px-8 py-3 rounded font-bold hover:bg-gold-700 transition-colors">
          返回首頁
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
